export default class VirtualizedAppDomainService {
    static get ADVISE_APP_NAME() {
        return "advise";
    }
    static get RECRUIT_APP_NAME() {
        return "recruit";
    }
    static get INSTRUCT_APP_NAME() {
        return "instruct";
    }
    static get ADMIN_APP_NAME() {
        return "admin";
    }
    static get STUDENT_APP_NAME() {
        return "student";
    }
    static get RESOURCES_APP_NAME() {
        return "resources";
    }
    // Not an actual app, acts as an app to figure out which app we should be in
    static get FIND_APP_NAME() {
        return "find";
    }
}
